import { type AccessControlConfig } from '../../../components/AccessControl/accessControl.utils'
import { Permission } from '../../../common/types'

export const StripeAssociationsAccessControl: AccessControlConfig = {
  permissions: Permission.Stripe,
  restrictedBannersAllowed: true,
}
